<template>
  <div class="screen-row">
    <el-row>
      <el-col :span="screenSpan"
              class="screen-name"
      >
        {{name || `&nbsp;`}}
      </el-col>
      <el-col :span="screenContentSpan" class="screen-content">
        <slot name="screenContent"></slot>
        <el-col :span="24/count"
                v-for="(item) in list"
                :key="dateKey ? item.dateKey : item"
                class="condition ellipsis"
        >
          <span class="ellipsis cursor-pointer condition-span"
                :class="{'condition-choosed': isChoosed(item)}"
                @click.stop="chooseHandle(item)"
          >
            {{label ? item[label] : item}}
          </span>
        </el-col>
      </el-col>
      <el-col :span="screenMoreSpan"
              class="screen-more"
              v-if="dataList.length > count"
      >
        <el-button size="mini"
                   :icon="showMore? 'el-icon-arrow-up' :' el-icon-arrow-down'"
                   @click="showMore=!showMore"
        >{{showMore?'收起':'更多'}}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showMore: false // 显示所有
    }
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
    // // 筛选条件名称块
    // screenSpan: {
    //   type: Number,
    //   default: 2
    // },
    // 筛选条件名称
    // name: {
    //   type: String,
    //   default: ''
    // },
    // 筛选条件内容
    // screenContentSpan: {
    //   type: Number,
    //   default: 22
    // },
    // 筛选条件
    // dataList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // dateKey: {
    //   type: String,
    //   default: ''
    // },
    // label: {
    //   type: String,
    //   default: ''
    // },
    // 筛选条件每行显示数量
    // count: {
    //   type: Number,
    //   default: 8
    // },
    // 是否显示更多项
    // showMoreItem: {
    //   type: Boolean,
    //   default: true
    // },
    // screenMoreSpan: {
    //   type: Number,
    //   default: 2
    // }
  },
  computed: {
    // 唯一标识
    id () {
      return this.params.id || ''
    },
    // 筛选条件名称块
    screenSpan () {
      return this.params.screenSpan || 3
    },
    // 筛选条件名称
    name () {
      return this.params.name || ''
    },
    // 筛选条件内容
    screenContentSpan () {
      return this.params.screenContentSpan || 19
    },
    // 筛选条件
    dataList () {
      return this.params.dataList || []
    },
    dateKey () {
      return this.params.dateKey || ''
    },
    label () {
      return this.params.label || ''
    },
    count () {
      return this.params.count || 8
    },
    // 是否显示更多项
    showMoreItem () {
      if (this.params.showMoreItem === true || this.params.showMoreItem === false) {
        return this.params.showMoreItem
      } else {
        return true
      }
    },
    screenMoreSpan () {
      return this.params.screenMoreSpan || 2
    },
    // 当前显示的数据
    list () {
      if (this.showMore || this.dataList.length <= this.count) {
        return this.dataList
      } else {
        return this.dataList.slice(0, this.count)
      }
    },
    // 多选
    multiple () {
      if (this.params.multiple === true || this.params.multiple === false) {
        return this.params.multiple
      } else {
        return false
      }
    },
    // 选中的值
    choosed () {
      if (this.params.choosed) {
        return this.params.choosed
      } else {
        if (this.multiple) {
          return []
        } else {
          return ''
        }
      }
    },
    // 是否树
    isTree () {
      if (this.params.isTree === true || this.params.isTree === false) {
        return this.params.isTree
      } else {
        return false
      }
    },
    // 树的children 字段
    treeChildren () {
      return this.params.treeChildren || 'children'
    },
    // 在子节点中父节点的key
    parentKey () {
      return this.params.parentKey || 'parentId'
    }
  },
  methods: {
    /**
     * 点击选中，若已选中则取消当前选中项，没选中增加或更改选中项
     */
    chooseHandle (item) {
      let id = ''
      if (this.dateKey) {
        id = item[this.dateKey]
      } else {
        id = item
      }
      let choosed = this.choosed
      if (this.multiple) {
        let index = this.choosed.findIndex(item => {
          return item === id
        })
        if (index > -1) {
          choosed.splice(index, 1)
        } else {
          choosed.push(id)
        }
      } else {
        if (this.choosed === id) {
          choosed = ''
        } else {
          choosed = id
        }
      }
      this.$emit('changeChoosed', {
        key: this.id,
        value: choosed
      })
    },
    // 判断当前项是否选中
    isChoosed (item) {
      let id = ''
      let isChoosed = false
      if (this.dateKey) {
        id = item[this.dateKey]
      } else {
        id = item
      }
      if (this.multiple) {
        let index = this.choosed.findIndex(item => {
          return item === id
        })
        if (index > -1) {
          isChoosed = true
        }
      } else {
        if (this.choosed === id) {
          isChoosed = true
        }
      }
      return isChoosed
    },
    // 根据子节点获取树的所有父节点
    findParent (parents = [], childNode, treeData = []) {
      let childId = ''
      if (this.dateKey) {
        childId = childNode[this.dateKey]
      } else {
        childId = childNode
      }
      if (treeData && treeData.length) {
        treeData.forEach(item => {
          let pId = ''
          if (this.dateKey) {
            pId = item[this.dateKey]
          } else {
            pId = item
          }
          if (pId === childId) {
            // 如果找到结果,保存当前节点
            parents.unshift(item)
            // 用当前节点再去原数据查找当前节点的父节点
            let target
            if (this.parentKey) {
              target = {
                [this.dateKey]: item[this.parentKey]
              }
            } else {
              // 实际针对无parentKey
              target = {
                [this.dateKey]: treeData[this.dateKey]
              }
            }
            this.findParent(parents, target, this.dataList)
          } else {
            if (item[this.treeChildren] instanceof Array) {
              // 没找到，遍历该节点的子节点
              this.findParent(parents, childNode, item[this.treeChildren])
            }
          }
        })
      }
      return parents
    }
  }
}
</script>
<style lang='scss' scoped>
.screen-row{
  line-height: 30px;
  background: #fff;
  border-top: 1px solid #dedede;
  >.el-row{
    display: flex;
  }
  .screen-name{
    background: #f2f2f2;
    color: #333333;
    padding-left: 10px;
  }
  .screen-content{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .condition{
      font-size: 12px;
      text-align: center;
      .condition-span{
        padding: 3px 5px;
      }
      .condition-choosed{
        border: 1px solid #2e88ff;
      }
    }
  }
  .screen-more{
    text-align: right;
  }
}
</style>
